import { Text } from '@components/gassan-ui/Typography/Text'
import { Field } from '@gassan-ui'
import { OptIns } from '@generated'
import { cn } from '@lib/cn'
import { useTranslation } from 'next-i18next'

export const OptinOptoutFormField = ({ optIn }: { optIn: OptIns }) => {
  const { title, label } = useCopy(optIn)

  const labelStyle = cn(
    'mb-4 flex w-full items-center border-b border-shade-300 pb-4',
    'first:border-t first:border-shade-300 first:pt-4',
  )

  return (
    <div className={labelStyle}>
      <Field
        mb="0"
        name={optIn}
        label={
          <div
            className={cn(
              'grid w-full items-start',
              '-mt-[0.15rem] grid-cols-1 gap-1',
              'xl:grid-cols-[250px_1fr] xl:gap-4',
            )}
          >
            <Text variant="regular" className="mb-0">
              {title}
            </Text>
            <Text variant="regular" className="mb-0 text-shade-500">
              {label}
            </Text>
          </div>
        }
        field="checkbox"
        gridColumn="span 12"
      />
    </div>
  )
}

const useCopy = (optIn: OptIns) => {
  const { t } = useTranslation('global-items')

  switch (optIn) {
    case OptIns.GassanNewsletter:
      return {
        title: t('gassan_newsletter_news_title'),
        label: t('gassan_newsletter_news_label'),
      }
    case OptIns.EventInvitations:
      return {
        title: t('gassan_newsletter_events_title'),
        label: t('gassan_newsletter_events_label'),
      }
    case OptIns.ChoicesNewsletter:
      return {
        title: t('choices_newsletter_title'),
        label: t('choices_newsletter_label'),
      }
  }
}
